import { CreateButton, FilterButton, TopToolbar } from 'react-admin'

const ProductListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton variant='contained' color='success' />
    </TopToolbar>
  )
}

export default ProductListActions